import _ from "lodash";
import { PeriodicTypeChecking } from "./components/functions";
import { PUBLICATIONS_PERIODIC_TYPES } from "constants/PublicationConstants";

const EXCLUDED_AR_FILTERS = [
  "إجمالي",
  "اجمالي",
  "إجمالى",
  "اجمالى",
  "الرقم العام",
];
const EXCLUDED_AR_EXACT_FILTERS = ["عام", "جملة"];

export function getPublications(indicatorsList) {
  if (
    indicatorsList.error ||
    indicatorsList.isLoading ||
    indicatorsList.data === undefined ||
    indicatorsList.data.data === undefined
  ) {
    return [];
  }
  return indicatorsList.data.data.publicationWithIndicators || [];
}

export function flattenIndicators(indicatorsList) {
  const publicationIndicators = getPublications(indicatorsList);
  if (!Object.keys(publicationIndicators).length) {
    return "";
  }
  const render = publicationIndicators.map((el) => el?.indicators);
  return render.length > 0 ? render.flat() : render;
}

export function findSelectedIndicator(indicators, indicatorIdData) {
  return (
    indicators?.length > 0 &&
    indicators.find((x) => x.indicatorId === +indicatorIdData)
  );
}

export function findIndicatorPublicationId(indicatorsList, indicatorId) {
  if (!indicatorId) return null;
  const publications = getPublications(indicatorsList);
  for (const publication of publications) {
    const indicator = publication.indicators.find(
      (item) => item.indicatorId === +indicatorId
    );
    if (indicator) return publication.id;
  }
  return null;
}

export function findIndicatorPublication(indicatorsList, indicatorId) {
  if (!indicatorId) return null;
  const publications = getPublications(indicatorsList);
  for (const publication of publications) {
    const indicator = publication.indicators.find(
      (item) => item.indicatorId === +indicatorId
    );
    if (indicator) return publication;
  }
  return null;
}

export function sortAscHeader(arr) {
  return arr.sort((a, b) => parseInt(a.sortingKey) - parseInt(b.sortingKey));
}

export function buildChartData({
  indicatorRows,
  selectedIndicators,
  periodicId,
  intl,
}) {
  if (!indicatorRows || selectedIndicators.length === 0) {
    return [];
  }

  const selectedIds = selectedIndicators.map((x) => x.id);

  return indicatorRows
    .filter((item) => selectedIds.indexOf(item.id) !== -1)
    .map((el) => {
      return el?.data?.map((x) => {
        const monthId =
          x.month != null
            ? parseInt(x.month) < 10
              ? "0" + x.month
              : x.month
            : 0;
        const quarterId = x.quarter ?? 0;
        const month = PeriodicTypeChecking({
          periodicId,
          value: x.month,
          type: PUBLICATIONS_PERIODIC_TYPES.MONTH,
        });
        const quarter = PeriodicTypeChecking({
          periodicId,
          value: x.quarter,
          type: PUBLICATIONS_PERIODIC_TYPES.QUARTER,
        });
        return {
          id: el.id,
          name: el.name,
          quarter:
            quarter !== "" ? intl.formatMessage({ id: quarter }) : quarter,
          month: month !== "" ? intl.formatMessage({ id: month }) : month,
          year: x.year,
          value: x.value,
          monthId,
          quarterId,
          translations: el.filterTranslations,
        };
      });
    });
}

export function getCheckboxOptions(indicatorRows) {
  if (!indicatorRows) return [];

  const unfilteredData = indicatorRows.filter(
    (item) =>
      EXCLUDED_AR_FILTERS.some((name) => item.name.includes(name)) ||
      EXCLUDED_AR_EXACT_FILTERS.some((name) => item.name === name)
  );
  const filteredData = indicatorRows.filter(
    (item) =>
      !EXCLUDED_AR_FILTERS.some((name) => item.name.includes(name)) &&
      !EXCLUDED_AR_EXACT_FILTERS.some((name) => item.name === name)
  );
  const sortedFilteredData = filteredData.sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const sortedData = unfilteredData.concat(sortedFilteredData);

  return sortedData.map((x) => ({
    id: x.id,
    name: x.name,
    translations: x.filterTranslations,
  }));
}

export function mapCheckboxList(indicatorRows) {
  if (!indicatorRows) return undefined;
  return indicatorRows.map((x) => ({
    id: x.id,
    name: x.name,
    translations: x.filterTranslations,
  }));
}

export function buildColHeaders(allChartData, intl) {
  const preparingData = [];
  for (let index = 0; index < allChartData.length; index++) {
    preparingData.push(
      allChartData[index].map((item) => ({
        headerName:
          item.month + " " + item.quarter + " " + item.year.toString(),
        sortingKey:
          item.year.toString() +
          item.monthId.toString() +
          item.quarterId.toString(),
      }))
    );
  }

  const setColHeader = preparingData.flat();
  const filteredColHeader = _.uniqBy(setColHeader, (x) => x.headerName);
  const sortedFilteredColHeader = sortAscHeader(filteredColHeader);

  return sortedFilteredColHeader.length > 0
    ? [
        {
          headerName: intl.formatMessage({ id: "indicator" }),
          isIndicatorName: true,
        },
        ...filteredColHeader,
      ]
    : [];
}

export function getChartImageFilename(visualization, currentLocale, extension) {
  if (visualization?.name) {
    return currentLocale === "ar"
      ? `الرسم البياني ل${visualization.name}.${extension}`
      : `chart-${visualization.indicatorTranslations?.[0]?.name}.${extension}`;
  }
  return `chart.${extension}`;
}

export function getTableExportFilename(visualization, currentLocale) {
  if (!visualization?.name) return "excel-sheet";
  return currentLocale === "ar"
    ? visualization.name
    : visualization.indicatorTranslations?.[0]?.name;
}
